(function () {
    function readThemeCookie() {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var c = cookies[i].trim();
            if (c.indexOf("UPTheme=") === 0) {
                try {
                    return JSON.parse(decodeURIComponent(c.substring(8)));
                } catch (e) {
                    console.warn("Unable to read the shared theme.");
                    return null;
                }
            }
        }
        return null;
    }

    function applyTheme(theme) {
        if (!theme || typeof theme.d !== "boolean") {
            return;
        }

        if (theme.v) {
            if (typeof theme.v !== "object" || Array.isArray(theme.v)) {
                return;
            }

            var themeVariablePattern = /^-?\d+(?:\.\d+)?\s+-?\d+(?:\.\d+)?%\s+-?\d+(?:\.\d+)?%$/;
            for (var key in theme.v) {
                if (Object.prototype.hasOwnProperty.call(theme.v, key) &&
                    (!/^[a-z0-9-]+$/i.test(key) ||
                        typeof theme.v[key] !== "string" ||
                        !themeVariablePattern.test(theme.v[key]))) {
                    return;
                }
            }
        }

        document.body.classList.toggle("dark", theme.d);
        localStorage.setItem("IsDarkMode", JSON.stringify(theme.d));

        if (theme.v) {
            var s = document.body.style;
            for (var variable in theme.v) {
                if (Object.prototype.hasOwnProperty.call(theme.v, variable) && theme.v[variable]) {
                    s.setProperty("--" + variable, theme.v[variable]);
                }
            }
        }
    }

    try {
        var theme = readThemeCookie();
        var d;
        if (theme && typeof theme.d === "boolean") {
            d = theme.d;
        } else {
            var r = localStorage.getItem("IsDarkMode");
            d = r !== null ? r === "true" : window.matchMedia("(prefers-color-scheme: dark)").matches;
        }

        document.body.classList.toggle("dark", d);
        applyTheme(theme);

        var previousTheme = document.cookie;
        window.setInterval(function () {
            if (document.cookie !== previousTheme) {
                previousTheme = document.cookie;
                applyTheme(readThemeCookie());
            }
        }, 1000);
    } catch (e) {
        console.warn("Unable to initialise the theme.");
    }
})();
